export default ":host ::ng-deep .mat-table-sticky {\n  z-index: 0 !important;\n}"